export default __webpack_public_path__ + "static/images/40b7bd51.png";